import { Validator } from '@vista-digital/validator';
export const defaultMemberJourneyListEvents = {
    onViewJourneyButtonClicked: undefined,
    onNoJourneysActionButtonClicked: undefined
};
export const memberJourneyListEventsValidator = Validator.object({
    onViewJourneyButtonClicked: Validator.optional(Validator.fn()),
    onNoJourneysActionButtonClicked: Validator.optional(Validator.fn())
});
